/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsiblePersonPhone/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import Checkbox from 'DesignSystem/Checkbox/index'
import ChoiceRadial from 'DesignSystem/ChoiceRadial/index'
import MaskedInput from 'DesignSystem/MaskedInput/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function ResponsiblePersonPhone({
  children,
  viewPath = "/App/Form/Data/ProvideData/ResponsiblePersonPhone",
  onChange,
  onSubmit,
  value,
  inputKey,
  disabled,
  onClickType,
  valueType,
  valueUsePatientPhone,
  onClickUsePatientPhone,
  valueNotifications,
  onClickNotifications,
  onClickConsentNotification,
  valueConsent
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="ResponsiblePersonPhone.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z29hgw5': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ResponsiblePersonPhone.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginTop={4}
 marginBottom={0}
 text="What is the phone number of the person responsible for the patient?"
/>
</div>
<MaskedInput
  viewPath={`${viewPath}/MaskedInput`}
 autoFocus={true}
 mask="phone"
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder="(000) 000-0000"
 type="text"
 initialValue={value}
 key={inputKey}
 disabled={disabled}
/>
<div
  data-testid="ResponsiblePersonPhone.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<ChoiceRadial
  viewPath={`${viewPath}/ChoiceRadial`}
 isDisabled={disabled}
 id="CELL"
 onClick={onClickType}
 selected={valueType}
 text="Cell"
/>
<ChoiceRadial
  viewPath={`${viewPath}/ChoiceRadial`}
 isDisabled={disabled}
 id="LANDLINE"
 marginLeft={8}
 onClick={onClickType}
 selected={valueType}
 text="Landline"
/>
</div>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 isSelected={valueUsePatientPhone}
 marginTop={16}
 onClick={onClickUsePatientPhone}
 text="Use Patient Phone"
/>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 isSelected={valueNotifications}
 marginTop={8}
 onClick={onClickNotifications}
 text="Yes, send me message notifications"
/>
<div
  data-testid="ResponsiblePersonPhone.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 marginTop={16}
 onClick={onClickConsentNotification}
 isSelected={valueConsent}
 text=""
/>
<div
  data-testid="ResponsiblePersonPhone.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="ResponsiblePersonPhone.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
By providing your phone number, you agree to receive text messages from this practice.
</span>
<span
  data-testid="ResponsiblePersonPhone.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
Message and data rates may apply. Message frequency varies. Reply STOP to opt-out.
</span>
</div>
</div>
<Status
  viewPath={`${viewPath}/Status`}
 onSubmit={onSubmit}
/>
</div>
{children}
</React.Fragment>)
}